import { Component, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'list-flat-item',
    templateUrl: 'list-flat-item.component.html',
    styleUrls: ['list-flat-item.component.scss'],
})
export class ListFlatItemComponent {
    @ViewChild('listFlatItem') readonly listFlatItem!: TemplateRef<unknown>;
}
